import React from 'react';
import Gallery from './Gallery';

export default props => {
  return (props.match && props.match.params.query) ? <Gallery query={props.match.params.query} /> : <Gallery query={"all"} />
}


// WEBPACK FOOTER //
// ./src/Components/QueryRoute.jsx